import React from "react";

const AddScheme = React.createContext();

export default AddScheme;